/*
 * Copyright (c) 2020.
 * Ducnq
 */

import {SERVER_API_PLATFORMJK} from '../../constans/index';
import {RSAA} from 'redux-api-middleware';
import headers from "../../utils/headers";
import {
    HEAR_UPDATE_FAILURE,
    HEAR_UPDATE_REQUEST,
    HEAR_UPDATE_SUCCESS
} from "../../types/index";

/**
 * HearUpdateOfPushNotifyAction
 */
const HearUpdateOfPushNotifyAction = (hearId, dataTarget) => ({


    [RSAA]: {
        endpoint: () => {
            return `${SERVER_API_PLATFORMJK}/api/hears/${hearId}`
        },
        method: "PUT",
        headers: (headers()),
        body: (() => {
            return JSON.stringify(dataTarget);
        }),
        types: [
            HEAR_UPDATE_REQUEST,
            {
                type: HEAR_UPDATE_SUCCESS,
                payload: async (action, state, res) => {
                    let data = [];
                    await res.json().then((json) => {
                        data = json.data
                    });

                    return {
                        "code": 0,
                        "type": HEAR_UPDATE_SUCCESS,
                        "data": data
                    }
                }
            },
            {
                type: HEAR_UPDATE_FAILURE,
                payload: async (action, state, res) => {

                    let message = "";
                    await res.json().then((json) => {
                        message = json.message;
                    });

                    return {
                        "code": 1,
                        "type": HEAR_UPDATE_FAILURE,
                        "message": message,
                        "data": [],
                    }
                }
            }
        ]
    }

});

export {HearUpdateOfPushNotifyAction}

